import { Button, Input, InputNumber, Popconfirm, Table } from "antd";

import React, { useMemo, useState } from "react";
import { styled } from "styled-components";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
// import Utils from "utils";
// import { permitKey, PermitValue } from "constants";
import {
  createDmnhomthuoc,
  getAllDmnhomthuoc,
  setAllDmnhomthuocList,
  updateDmnhomthuoc,
  deleteDmnhomthuoc,
} from "store/slices/sale/danhmucSlice";

import { initDmnhomthuoc } from "views/app-views/sale/category/Dmnhomthuoc";
import Utils from "utils";
const formater = new Intl.NumberFormat("vi-VN");
// formatter and parser input number
export const formatterNumber = (val) => {
  if (!val) return 0;
  return formater.format(val);
};

// export const parserNumber = (val) => {
//   if (!val) return 0;
//   return Number.parseFloat(
//     val.replace(/\$\s?|(\.*)/g, "").replace(/(\,{1})/g, ".")
//   ).toFixed(5);
// };
const TableDmnhomthuocList = ({
  allDmnhomthuocList,
  reloadData,
  permitList = [],
}) => {
  const [editingKey, setEditingKey] = useState("");
  //const isEditing = (record) => record.key === editingKey;

  const dispatch = useDispatch();

  // const allowLock = Utils.checkPermitValue(
  //   PermitValue.khoa,
  //   permitList,
  //   permitKey.crm_hospital
  // );
  // const allowEdit = Utils.checkPermitValue(
  //   PermitValue.sua,
  //   permitList,
  //   permitKey.crm_hospital
  // );
  // const allowDelete = Utils.checkPermitValue(
  //   PermitValue.xoa,
  //   permitList,
  //   permitKey.crm_hospital
  // );

  const onChangeText = (type, record) => (e) => {
    const newData = allDmnhomthuocList.slice(0);
    const value = e?.target?.value ?? e;
    const index1 = newData.findIndex(
      (item) => item.manhomthuoc === record.manhomthuoc
    );
    newData[index1] = { ...newData[index1], [type]: value };
    dispatch(setAllDmnhomthuocList(newData));
  };
  const onClickAction = (record, index) => {
    const newData = allDmnhomthuocList.slice(0);
    const payload = {
      manhomthuoc: record.manhomthuoc,
      tennhomthuoc: record.tennhomthuoc,
      viettat: record.viettat,
      sapxep: record.sapxep,
      onSuccess: () => {
        dispatch(getAllDmnhomthuoc());
      },
    };
    if (record.action === initDmnhomthuoc.action) {
      dispatch(createDmnhomthuoc(payload));
    } else {
      if (record.manhomthuoc !== null && record.action !== "update") {
        const index1 = newData.findIndex(
          (item) => item.manhomthuoc === record.manhomthuoc
        );
        newData[index1] = { ...newData[index1], action: "update" };
        dispatch(setAllDmnhomthuocList(newData));
      } else {
        dispatch(updateDmnhomthuoc(payload));
      }
    }
  };

  const tableColumns = useMemo(
    () => [
      {
        title: "STT",
        width: 50,
        align: "center",
        render: (_, __, index) => index + 1,
      },
      {
        title: "Mã số",
        width: 90,
        dataIndex: "manhomthuoc",
      },
      {
        title: "Tên",
        width: 180,
        dataIndex: "tennhomthuoc",
        render: (_, record, index) =>
          record.action ? (
            <Input
              style={{ width: "100%" }}
              value={record.tennhomthuoc}
              placeholder="Nhập tên..."
              onChange={onChangeText("tennhomthuoc", record)}
            />
          ) : (
            record.tennhomthuoc
          ),
      },
      {
        title: "Viết tắt",
        width: 100,
        dataIndex: "viettat",
        render: (_, record, index) =>
          record.action ? (
            <Input
              style={{ width: "100%" }}
              value={record.viettat}
              placeholder="Tên viết tắt..."
              onChange={onChangeText("viettat", record)}
            />
          ) : (
            record.viettat
          ),
      },
      {
        title: "Sắp xếp",
        width: 80,
        dataIndex: "sapxep",
        render: (_, record, index) =>
          record.action ? (
            <InputNumber
              style={{ width: "100%" }}
              step={1}
              value={record.sapxep}
              placeholder="Nhập thứ tự"
              formatter={(value) => formatterNumber(value)}
              parser={(value) => Utils.parserNumber(value)}
              onChange={onChangeText("sapxep", record)}
            />
          ) : (
            record.sapxep
          ),
      },
      {
        fixed: "right",
        width: 90,
        align: "center",
        dataIndex: "action",
        render: (_, record, index) => (
          <>
            {record.action === "initial" ? (
              <Button
                //disabled={!record.tenhh || !allowView(PermitValue.them)}
                title={"Thêm thông tin"}
                onClick={() => onClickAction(record, index)}
                className="mr-2"
                icon={<PlusOutlined />}
                shape="circle"
              />
            ) : (
              <>
                <Button
                  disabled={
                    editingKey !== "" && editingKey !== record.manhomthuoc
                  }
                  title={"Sửa thông tin"}
                  //disabled={!allowView(PermitValue.sua)}
                  onClick={() => {
                    setEditingKey(editingKey !== "" ? "" : record.manhomthuoc);
                    onClickAction(record, index);
                  }}
                  className="mr-2"
                  icon={
                    record.action === "update" ? (
                      <SaveOutlined />
                    ) : (
                      <EditOutlined />
                    )
                  }
                  shape="circle"
                />
                <Popconfirm
                  title="Bạn có muốn xóa không?"
                  placement="topLeft"
                  onConfirm={() => {
                    dispatch(
                      deleteDmnhomthuoc({
                        id: record.manhomthuoc,
                        onSuccess: (r) => {
                          dispatch(getAllDmnhomthuoc());
                        },
                      })
                    );
                  }}
                >
                  <Button
                    disabled={editingKey !== ""}
                    title={"Xóa thông tin"}
                    //disabled={!allowView(PermitValue.xoa)}
                    className="mr-2"
                    icon={<DeleteOutlined type="primary" />}
                    shape="circle"
                  />
                </Popconfirm>
              </>
            )}
          </>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allDmnhomthuocList]
  );
  return (
    <CustomTable
      columns={tableColumns}
      dataSource={allDmnhomthuocList}
      rowKey={(item) => item?.manhomthuoc}
      bordered
      style={{ padding: "0px" }}
      fixed={true}
      scroll={{ x: "max-content" }}
    />
  );
};

const CustomTable = styled(Table)`
  .ant-table-tbody > tr > td {
    padding: 2px;
  }
`;

export default TableDmnhomthuocList;
